import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../theme/hooks/useAlerts'
import { updateProfile } from '../services/updateProfile'

import { queryKey } from './useProfile'

export { useUpdateProfile }

const useUpdateProfile = () => {
  const queryClient = useQueryClient()
  const { successAlert, errorAlert } = useAlerts()

  return useMutation({
    mutationFn: updateProfile,
    onSuccess: (profile) => {
      queryClient.setQueryData([queryKey], profile)
      successAlert('Accountgegevens opgeslagen')
    },
    onError: (error: any) => {
      errorAlert('Fout bij opslaan accountgegevens', error)
    },
  })
}
